const memberBillableTypes = {
  billable: { id: 'billable', name: 'Billable Members' },
  non_billable: { id: 'non_billable', name: 'Non-Billable Members' },
};

export default memberBillableTypes;
